import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map, filter, take } from 'rxjs/operators';
import { UserQuery } from '../state/user.query';

@Injectable({
  providedIn: 'root',
})
export class RolesGuard {
  private userQuery = inject(UserQuery);
  private router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const expectedRoles = next.data.roles as string[];
    const currentRoute = state.url;

    return combineLatest([this.userQuery.orgUser$, this.userQuery.initialized$]).pipe(
      filter(([orgUser, initialized]) => {
        // Wait for user to be fully initialized
        if (!initialized) {
          console.log('⏳ RolesGuard: Waiting for user initialization...');
          return false;
        }

        // Ensure we have a valid user (not the initial NO_USER state)
        if (!orgUser.id || orgUser.id === 'NO_USER') {
          console.log('⏳ RolesGuard: Waiting for valid orgUser...');
          return false;
        }

        // Ready to check roles
        return true;
      }),
      take(1),
      map(([orgUser]) => {
        // Check if user has any of the expected roles
        const hasRole = orgUser.roles.some((role: any) => expectedRoles.includes(role));

        if (hasRole) {
          console.log(`✅ RolesGuard: User has required role(s) for ${currentRoute}`);
          return true;
        }

        console.log(`🚫 RolesGuard: User does not have required roles: ${expectedRoles.join(', ')}`);
        return this.router.createUrlTree(['/app/home']);
      })
    );
  }
}
